import { render, staticRenderFns } from "./MyRecord.vue?vue&type=template&id=a9e29fe2&scoped=true&lang=html&"
import script from "./MyRecord.vue?vue&type=script&lang=ts&"
export * from "./MyRecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e29fe2",
  null
  
)

export default component.exports